export function focusEditorElement(editorId) {
  var parentElement = document.querySelector("[data-focus-id=\"".concat(editorId, "\"]"));
  if (!(parentElement instanceof HTMLElement)) {
    return;
  }
  parentElement.focus({
    preventScroll: true
  });
}